import { useState } from 'react';

import { G500LiteAuthInfoType } from '../../feature/type/AuthInfoType';
import { initG500LiteAuthInfo } from '../../../common/const/commonConst';

/**
 * 初回登録時に入力するG500Liteログイン情報の状態管理用カスタムフック
 */
export const useStateG500LiteRegistrationAuthInfo = () => {
	const [g500LiteRegistrationAuthInfo, setG500LiteRegistrationAuthInfo] = useState<G500LiteAuthInfoType>(initG500LiteAuthInfo); // G500Liteのログイン情報の管理

	return {
		g500LiteRegistrationAuthInfo,
		setG500LiteRegistrationAuthInfo,
	};
};
